// extracted by mini-css-extract-plugin
export var colImageParent = "displayCard-module--colImageParent--e28d7";
export var desktopText = "displayCard-module--desktopText--f43bb";
export var displayCardCol = "displayCard-module--displayCardCol--cac61";
export var fullLink = "displayCard-module--fullLink--a7055";
export var mobileText = "displayCard-module--mobileText--7025b";